<script>
import Vue from 'vue'
import TextInput from "@/Shared/TextInput";
import TabLayout from "@/Pages/Settings/Shared/TabLayout";

export default Vue.extend({
    name: "PasswordValidation",
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')},
    components: {
        TabLayout,
        TextInput,
    },
    props: {
        errors: Object,
        secret: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                password: null,
            }),
        }
    },
    computed: {
        canSubmit() {
            return this.form.password?.length > 0 && !this.form.processing;
        },
    },
    methods: {
        submit() {
            this.form.post(
                this.route(
                    'nl.employeedashboard.settings.two-factor-authentication.regenerate-recovery-codes.verify.password.post',
                ),
            );
        },
    },
})
</script>

<template>
    <tab-layout
        :title="Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="twoFactorAuthentication"
        :hideMsg="true"
    >
        <p class="font-poppins font-weight-light color-dark-blue">
            {{ Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.password.heading') }}
        </p>

        <form @submit.prevent="submit()">
            <div class="row mb-4">
                <div class="form-group col-12 col-md-4">
                    <text-input
                        v-model="form.password"
                        :label="Lang.get('employeedashboard::shared.placeholder.password')"
                        :placeholder="Lang.get('employeedashboard::shared.placeholder.password')"
                        :error="errors.password"
                        type="password"
                    />
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <button
                        type="submit"
                        :disabled="!canSubmit"
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                        {{ Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.password.button') }}
                    </button>
                </div>
            </div>
        </form>
    </tab-layout>
</template>
